export default "__VITE_ASSET__C0ROCynI__"